import React, { Component } from 'react'

import '../css/Footer.css';

class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            content: [
                      {
                          "title": {
                              "en": "About Us",
                              "zh": "關於我們",
                              "ja": "会社情報"
                          },

                          "content": {
                              "en": ["Home", "About Nexuni", "Technology", "How to Collaborate?"],
                              "zh": ["首頁", "公司理念", "核心技術", "合作流程"],
                              "ja": ["ホーム", "Nexuni について", "技術", "協力方法"]
                          },

                          "action": [() => this.props.general_switch_page('/MainPage', ''),
                                  () => this.props.general_switch_page('/GeneralPage', "about_us"),
                                  () => this.props.general_switch_page('/GeneralPage', "core_technology"),
                                  () => this.props.general_switch_page('/GeneralPage', 'colab_flow')]
                      },
                    //   {
                    //       "title": {
                    //           "en": "Products",
                    //           "zh": "產品",
                    //           "ja": "製品"
                    //       },
                    //       "content": {
                    //           "en": ["Solutions", "Customer Stories", "How to Collaborate?"],
                    //           "zh": ["解決方案", "實際案例", "合作流程"],
                    //           "ja": ["ソリューション", "顧客事例", "協力方法"]
                    //       },

                    //       "action": [() => this.props.general_switch_page('/SolutionPage', ''),
                    //               () => this.props.general_switch_page('/StoryPage', ""),
                    //               () => this.props.general_switch_page('/GeneralPage', 'colab_flow')]
                    //   },
                      {
                          "title": {
                              "en": "Careers",
                              "zh": "Nexuni 生涯",
                              "ja": "採用情報"
                          },

                          "content": {
                              "en": ["Open Positions", "Internship Program", "Life At Nexuni"],
                              "zh": ["開放職缺", "實習生計畫", "文化與環境"],
                              "ja": ["募集職種", "インターンシップ", "企業文化"]
                          },

                          "action": [() => this.props.general_switch_page('/GeneralPage', 'career'), 
                                  () => this.props.general_switch_page('/GeneralPage', 'intern'),
                                  () => this.props.general_switch_page('/GeneralPage', 'environment')] // () => this.props.general_switch_page('/GeneralPage', 'partner')
                      },
                      {
                          "title": {
                              "en": "Media",
                              "zh": "媒體影音",
                              "ja": "メディア"
                          },

                          "content": {
                              "en": ["Media", "Youtube"],
                              "zh": ["媒體", "Youtube"],
                              "ja": ["メディア", "Youtube"]
                          },

                          "action": [() => this.props.general_switch_page('/GeneralPage', 'news'), 
                                  () => this.openInNewTab('https://www.youtube.com/@nexuni')]
                      },
                      {
                          "title": {
                              "en": "Contact Us",
                              "zh": "聯繫我們",
                              "ja": "お問い合わせ"
                          },

                          "content": {
                              "en": ["Instagram", "Linkedin", "Facebook", "Contact us"],
                              "zh": ["Instagram", "Linkedin", "Facebook", "聯絡我們"],
                              "ja": ["Instagram", "Linkedin", "Facebook", "お問い合わせ"]
                          },
                          "action": [() => this.openInNewTab('https://www.instagram.com/nexuni.co/'),
                                  () => this.openInNewTab('https://www.linkedin.com/company/nexuni'),
                                  () => this.openInNewTab('https://www.facebook.com/profile.php?id=100070603490643'),
                                  () => this.props.general_switch_page('/ContactUsPage', '')]
                      }]
        }

      this.openInNewTab = this.openInNewTab.bind(this)
    }

    openInNewTab(url) {
        var win = window.open(url, '_blank');
        if (win != null) {
            win.focus();
        }
    }
    
    
    render() {

        return (
            <div className="v2_footer_section">
                <div className="v2_footer_btn_section">

                    {this.state.content.map((item, index) => (
                        <div key={index} className="v2_footer_btn_list">
                            <h4>{item["title"][this.props.lang]}</h4>
                            {item["action"].map((action, i) => (
                                <button key={i} onClick={action}><span>{item["content"][this.props.lang][i]}</span></button>
                            ))}
                        </div>
                    ))}
                    
                </div>
                <div className="v2_copyright_section">
                    <div className="v2_copyright">&copy;2025 - <strong>Nexuni Co Ltd. All rights reserved.</strong></div>
                    <button className="v2_security_policy_btn" onClick={() => this.props.general_switch_page('/GeneralPage', 'security_policy')}>
                        <span>{this.props.lang === 'en' && "Information Security Policy"}
                        {this.props.lang === 'zh' && "資訊安全政策"}
                        {this.props.lang === 'ja' && "情報セキュリティ方針"}</span>
                    </button>
                </div>
            </div>
        );
    }
}

export default Footer;